import React from 'react';
import { TeamMember } from '../team-member';

export class TeamSection extends React.Component {
  constructor (props) {
    super(props);
    this.state = {};
  }

  render () {
    return (
      <section className="team-section">
        <h2 className="team-section__title">{this.props.title}</h2>
        <div className="team-section__content">
          { this.props.teamMembers?.map(member => <TeamMember {...member} />) }
        </div>
      </section>
    );
  }
}
